import React from 'react'
import styled from 'styled-components'
import { useSchoolContext } from '../hooks'

export const SiderLogo: React.FC = () => {
  const { logo } = useSchoolContext()
  return (
    <ImgWrapper>
      <img
        src={logo || '/logo.svg'}
        height={32}
      />
    </ImgWrapper>
  )
}

const ImgWrapper = styled.div``
